import React, { useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './texteditor.css'
function RichTextEditor({content,setContent}) {

  const modules = {
    toolbar: [
      [{ 'header': [1, 2, 3, false] }],
      [{ 'font': [] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'color': [] }, { 'background': [] }],
      [{ 'align': [] }],
      ['blockquote', 'code-block'],
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      ['link', 'image'],
      ['clean']
    ],
    clipboard: {
      matchVisual: false,
    }
  };

  const formats = [
    'header', 'font',
    'bold', 'italic', 'underline', 'strike', 'blockquote', 'code-block',
    'list', 'bullet',
    'link', 'image',
    'color', 'background', 'align'
  ];

  return (
    <div style={{
      width: '100%',
      maxWidth: '800px',
      fontFamily: "'Segoe UI', 'Helvetica Neue', Arial, sans-serif",
      color: '#333'
    }}>
      <div style={{
        border: '1px solid #E0E0E0',
        borderRadius: '4px',
        overflow: 'hidden',
        marginBottom: '16px'
      }}>
        <ReactQuill
          theme="snow"
          value={content}
          onChange={setContent}
          modules={modules}
          formats={formats}
          placeholder={window.navigator.language.startsWith('es') ? 
            'Escribe tu contenido aquí...' : 
            window.navigator.language.startsWith('fr') ? 
            'Écrivez votre contenu ici...' : 
            'Write your content here...'}
          style={{
            height: '300px',
            backgroundColor: '#FFFFFF',
            border: 'none'
          }}
        />
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '8px 12px',
          backgroundColor: '#F8F8F8',
          fontSize: '13px',
          color: '#666',
          borderTop: '1px solid #E0E0E0'
        }}>
          <div>
            {window.navigator.language.startsWith('es') ? 
              'Formatos soportados: ' : 
              window.navigator.language.startsWith('fr') ? 
              'Formats pris en charge: ' : 
              'Supported formats: '}
            {formats.slice(0, 5).join(', ')}...
          </div>
          <div>
            {window.navigator.language.startsWith('es') ? 
              'Caracteres: ' : 
              window.navigator.language.startsWith('fr') ? 
              'Caractères: ' : 
              'Characters: '}
            {content.replace(/<[^>]*>/g, '').length}
          </div>
        </div>
      </div>
    </div>
  );
}

export default RichTextEditor;